import 'unfetch'
// import '../scss/form.scss'
import * as fields from './fields'
import Form        from './form'

document.addEventListener('app:load', init)

function init()
{
	if (typeof app_form === 'undefined')
	{
		return
	}
	
	const formsStyle = document.querySelectorAll('form[data-form-style]')
	const formsInit = document.querySelectorAll('form[data-form-init]')
	
	if (formsStyle)
	{
		formsStyle.forEach(el =>
		{
			fields.init(el)
		})
	}
	
	if (formsInit)
	{
		formsInit.forEach(el =>
		{
			const form = new Form()
			
			form.init(el)
		})
	}
}
